const authMethods = {
  Microsoft: 'microsoft',
  Google: 'google',
  OTP: 'otp',
  SAML: 'saml',
  Password: 'password'
};

export default authMethods;
